import { Drawer, Flex, Form, Typography } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const AssetDrawer = styled(Drawer)`
  .ant-drawer-header {
    border-bottom: none;
  }
  .ant-drawer-header-title {
    flex-direction: row-reverse;
  }
  .ant-drawer-close {
    margin-right: 0;
  }
  .ant-drawer-body {
    padding: 0;
  }
  .ant-drawer-footer {
    border-top: none;
    padding: 0;
  }
`;

export const AssetFormItem = styled(Form.Item)`
  &&&& .ant-form-item-item-required::before {
    display: none;
  }

  &&&& .ant-form-item-item-required::after {
    content: '*';
    color: ${COLOR_OPTIONS.RED_50};
    margin-left: 4px;
  }
`;

export const DrawerContent = styled.div`
  padding: 0 24px;
`;

export const Footer = styled(Flex).attrs({ justify: 'end', gap: 8 })`
  padding: 16px 24px;
`;

export const SelectedTrapsContainer = styled(Flex).attrs({ gap: 10, align: 'center' })`
  padding: 12px 16px;
  margin-bottom: 24px;
  height: 48px;
  background-color: ${COLOR_OPTIONS.NEUTRAL_10};
`;

export const SelectedTrapsText = styled(Typography.Text)`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.105px;
  color: ${COLOR_OPTIONS.NEUTRAL_60};
`;
